import BackButton from 'components/backButton'
import { MasterDataUpdateForm } from 'components/masterData'
import { Helmet } from 'react-helmet'
import { useNavigate } from 'react-router-dom'
import { fetchMasterDataById, syncErpPricing } from 'utils/api/masterDataApi'
import { useParams } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { PAGE_MASTER_DATA, PAGE_NOT_FOUND } from 'utils/constants'
import { Button, Spinner } from 'components/common'
import { useSafeBack } from 'hooks'
import toast from 'react-hot-toast'
import { handleError } from 'utils/helpers/handleError'
import EcomClusterPriceList from 'pages/ecomPricing/ecomClusterPriceList'
import { PurchaseTimerSection } from 'components/purchaseTimer'
import { PRODUCT_TYPE } from 'types/bundleProduct'

const MasterDataUpdate = () => {
  const navigate = useNavigate()
  const { id } = useParams()
  const [catalogue, setCatalogue] = useState<Record<string, any>>({})
  const [loading, setLoading] = useState<boolean>(true)
  const [priceSyncLoading, setPriceSyncLoading] = useState(false)

  const handleBack = useSafeBack(PAGE_MASTER_DATA.path)

  const getMasterDataCatalogue = async (id: string) => {
    try {
      const { data } = await fetchMasterDataById(id)
      setCatalogue({ ...data })
    } catch (error) {
      navigate(PAGE_NOT_FOUND.path)
    } finally {
      setLoading(false)
    }
  }

  // To initially fetch Master data if id is present
  useEffect(() => {
    if (id) {
      getMasterDataCatalogue(id)
    }
  }, [])

  const handlePriceSync = async () => {
    setPriceSyncLoading(true)

    const toastId = toast.loading('Syncing Pricing ', {
      duration: Infinity,
    })
    try {
      await syncErpPricing(catalogue?._id)
      toast.success('Price Syncing Started Successfully', {
        id: toastId,
        duration: 3000,
      })
    } catch (error) {
      handleError(error, toastId)
    } finally {
      setPriceSyncLoading(false)
    }
  }

  if (loading) {
    return <Spinner />
  }

  return (
    <>
      <Helmet>
        <title>GAG Aggregator | Update Master Data</title>
      </Helmet>

      <BackButton handleBack={handleBack} />

      {catalogue && (
        <>
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2 py-3">
              <h1 className="text-lg font-bold">{catalogue?.description}</h1>
              {catalogue?.productType === PRODUCT_TYPE.BUNDLE && (
                <span className="rounded-full bg-button-primary px-2.5 py-1 text-xs font-medium text-button-secondary">
                  Bundle Product
                </span>
              )}
              {catalogue?.isThirdPartyProduct && (
                <span className="rounded-full bg-amber-100 px-2.5 py-1 text-xs font-medium text-amber-700">
                  Pharmacy Product
                </span>
              )}
            </div>
            {!catalogue.blockPriceSync && (
              <Button
                size="medium"
                buttonText={'Sync Price'}
                onClick={handlePriceSync}
                loading={priceSyncLoading}
              />
            )}
          </div>
          <MasterDataUpdateForm catalogue={catalogue} />{' '}
          {catalogue?.ecomPricing && catalogue?.ecomPricing.length > 0 && (
            <EcomClusterPriceList priceList={catalogue?.ecomPricing} />
          )}
          {catalogue?.purchaseTimers?.length ? (
            <PurchaseTimerSection
              barcode={catalogue?._id}
              purchaseTimers={catalogue?.purchaseTimers || []}
              onRefetch={() => id && getMasterDataCatalogue(id)}
            />
          ) : (
            <></>
          )}
        </>
      )}
    </>
  )
}

export default MasterDataUpdate
